export default "/images/view-progress.svg?80deb96af66cdec6beba592d62970fd5";